<div class="flex flex-col h-full">
  <p-toolbar>
    <ng-template pTemplate="start">
      <p-button
        routerLink="/brugeradm/roller"
        [queryParams]="{ id: -1 }"
        icon="pi pi-plus"
        label="Opret rolle"
        class="mr-2"
      />
    </ng-template>
    <ng-template pTemplate="end"> </ng-template>
  </p-toolbar>
  @let apiResponse = data.value(); @if (apiResponse) {
  <p-table
    [value]="apiResponse.data"
    showGridlines
    stripedRows
    [scrollable]="true"
    scrollHeight="flex"
    [loading]="data.isLoading()"
    class="flex-1 overflow-hidden p-datatable-sm mt-4"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="navn" style="width: 300px">
          Navn
          <p-sortIcon field="navn" />
        </th>
        <th pSortableColumn="beskrivelse">
          Beskrivelse
          <p-sortIcon field="beskrivelse" />
        </th>
        <th pSortableColumn="tilladEkstern" style="width: 140px">
          Tillad ekstern
          <p-sortIcon field="tilladEkstern" />
        </th>
        <th pSortableColumn="tilladEkstern" style="width: 140px">
          Admin lokalt
          <p-sortIcon field="tilladEkstern" />
        </th>
        <th pSortableColumn="adminRettighed" style="width: 200px">
          Admin rettighed
          <p-sortIcon field="adminRettighed" />
        </th>
      </tr>
    </ng-template>
    <ng-template [appTableRow]="apiResponse.data" pTemplate="body" let-rolle>
      <tr
        [routerLink]="['/brugeradm', 'roller']"
        [queryParams]="{ id: rolle.id }"
        class="cursor-pointer"
      >
        <td>{{ rolle.navn }}</td>
        <td>{{ rolle.beskrivelse }}</td>
        <td class="!text-center">
          @if (rolle.tilladEkstern) {
          <i class="pi pi-check"></i>
          }
        </td>
        <td class="!text-center">
          @if (rolle.tilladLokalAdmin) {
          <i class="pi pi-check"></i>
          }
        </td>
        <td>{{ rolle.adminRettighed }}</td>
      </tr>
    </ng-template>
  </p-table>
  }
</div>
